import { ModelDropdown } from "@/components/molecules/ModelDropdown/ModelDropdown";
import type React from "react";
import { useMemo } from "react";
import { getAvailableWeatherModels } from "./ModelSelectUtils";

export type ModelDropdownWIthStationProps = {
  onModelChange: (model: string) => void;
  availableModels?: string[];
  currentModel?: string | null;
  hasStationModels?: boolean;
};

export const ModelDropdownWithStation: React.FC<ModelDropdownWIthStationProps> = ({ ...props }) => {
  const orderedModels = useMemo(() => {
    const availableModels = props.availableModels ?? [];
    const sortedModels = [...availableModels].sort((a, b) => a.localeCompare(b));

    let finalModels = sortedModels.includes("mix") ? ["mix", ...sortedModels.filter((m) => m !== "mix")] : sortedModels;

    const modelBefore = props.currentModel;
    if (modelBefore && finalModels.includes(modelBefore)) {
      finalModels = [modelBefore, ...finalModels.filter((m) => m !== modelBefore)];
    }

    return finalModels;
  }, [props.availableModels, props.currentModel]);

  const availableWeatherModels = getAvailableWeatherModels(orderedModels, props.hasStationModels);

  return (
    <ModelDropdown
      options={
        availableWeatherModels.map((model) => {
          return { id: model.identifier, title: model.name };
        }) || []
      }
      onChange={props.onModelChange}
      placeholder={"Select a model"}
      value={props.currentModel || "mix"}
    />
  );
};
